module.exports = __webpack_public_path__ + "static/media/gamequiz-menu.fd99b309.jpg";